module.exports = __webpack_public_path__ + "1b3d7992beba895776379291db2d07df.svg";